/**
 * The mockup's pager window (grants.html:964): a fixed five-number window
 * around the current page, no ellipsis, no first/last anchors —
 * `from = max(1, page−2); to = min(pages, from+4); from = max(1, to−4)`.
 */
export function ComputePageWindow(current: number, totalPages: number): number[] {
    const total = Math.max(1, Math.floor(totalPages));
    const cur = Math.min(Math.max(1, Math.floor(current)), total);
    let from = Math.max(1, cur - 2);
    const to = Math.min(total, from + 4);
    from = Math.max(1, to - 4);
    return Array.from({ length: to - from + 1 }, (_, i) => from + i);
}
